import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import { Typography, FormTextStyled } from '../styled'
import { CheckRow } from './fieldStyled'

export default function FormCheckbox({ name, label, required }) {
  const { control } = useFormContext()
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <div className="mb-2">
          <CheckRow>
            <input
              type="checkbox"
              checked={!!field.value}
              onChange={(e) => field.onChange(e.target.checked)}
              style={{ marginTop: '3px' }}
            />
            <Typography size="13px">
              {label}
              {required && <span className="text-danger">*</span>}
            </Typography>
          </CheckRow>
          {fieldState.error && (
            <FormTextStyled isError>{fieldState.error.message}</FormTextStyled>
          )}
        </div>
      )}
    />
  )
}

FormCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  required: PropTypes.bool,
}
